export default "__VITE_ASSET__D2Kz7DnC__"